import React from 'react';
import img from '../../Assets/aboutBg.jpg';
import './aboutUs.css';
import data from './MissionData.json';
import MissionVision from './MissionVision';
import featuresData from './Features.json';
import FeaturesSection from './FeaturesSection';
import AnimatedSection from '../AnimatedSection';

const AboutUs = () => {
  return (
    <>
      <div className="about-us-conatiner">
        <div className="about-us-image">
          <img src={img} alt="" />
        </div>

        <div className="about-us-info">
          <AnimatedSection
            x={0}
            y={50}
            amount={0.4}
          >
            <div className="about-us-title">
              <h2>Biz Kimiz ?</h2>
            </div>
          </AnimatedSection>

          <AnimatedSection
            x={0}
            y={50}
            amount={0.4}
          >
            <div className="about-us-text">
              <p>
                Üniversitemizin lojman yönetim sistemi, akademik ve idari personelimizin
                barınma ihtiyaçlarını en iyi şekilde karşılamak amacıyla kurulmuştur.
                Güvenilir, şeffaf ve kullanıcı dostu bir hizmet sunmayı hedefleyen ekibimiz,
                modern teknolojilerle donatılmış bir platform üzerinden sizlere hizmet
                vermektedir.
              </p>
            </div>
          </AnimatedSection>
        </div>

        <div className="about-box">
          {data.map((item) => (
            <MissionVision item={item} key={item.id} />  
          ))}
        </div>


        <div className="features-container">
          {featuresData.map((item, index) => (
            
              <FeaturesSection item={item} key={index} />
            
          ))}
        </div>

      </div>
    </>
  );
};

export default AboutUs;
